'use client';

import _defineProperty from "/codebuild/output/src3339/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src3339/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src3339/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import { useScrollAreaContext } from '../ScrollArea.context.mjs';
import { useResizeObserver } from '../use-resize-observer.mjs';
var Corner = forwardRef(function (props, ref) {
  var style = props.style,
    others = _objectWithoutProperties(props, _excluded);
  var ctx = useScrollAreaContext();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var hasSize = Boolean(width && height);
  useResizeObserver(ctx.scrollbarX, function () {
    var _ctx$scrollbarX;
    var h = ((_ctx$scrollbarX = ctx.scrollbarX) === null || _ctx$scrollbarX === void 0 ? void 0 : _ctx$scrollbarX.offsetHeight) || 0;
    ctx.onCornerHeightChange(h);
    setHeight(h);
  });
  useResizeObserver(ctx.scrollbarY, function () {
    var _ctx$scrollbarY;
    var w = ((_ctx$scrollbarY = ctx.scrollbarY) === null || _ctx$scrollbarY === void 0 ? void 0 : _ctx$scrollbarY.offsetWidth) || 0;
    ctx.onCornerWidthChange(w);
    setWidth(w);
  });
  return hasSize ? /* @__PURE__ */jsx("div", _objectSpread(_objectSpread({}, others), {}, {
    ref: ref,
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: width,
      height: height
    })
  })) : null;
});
var ScrollAreaCorner = forwardRef(function (props, ref) {
  var ctx = useScrollAreaContext();
  var hasBothScrollbarsVisible = Boolean(ctx.scrollbarX && ctx.scrollbarY);
  var hasCorner = ctx.type !== "scroll" && hasBothScrollbarsVisible;
  return hasCorner ? /* @__PURE__ */jsx(Corner, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })) : null;
});
export { Corner, ScrollAreaCorner };